export default __webpack_public_path__ + "static/media/A4.27fc4877.png";